import type { IconSvgObject } from './types';

const FolderInputIcon: IconSvgObject = [
  ["path", { d: "M9.00002 17L12 14L9 11M11 14L2 14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V18M12.0179 6.99446L9.60016 3.79437C9.22218 3.29407 8.63144 3 8.0044 3H4C2.89543 3 2 3.89543 2 5V10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default FolderInputIcon;
